import { take } from '../../util/takePayload';
export const getNew = () => ({
    name: '',
    email: '',
});
export const fromGql = (gqlUser) => (Object.assign({}, take(gqlUser, 'id', 'name', 'email')));
//# sourceMappingURL=User.js.map